import { STATUS_LABELS, STATUS_VARIANT } from "./status.js";
import "react";
import { Tag } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/instance/ActivityEvalStatusTag.tsx
function ActivityEvalStatusTag({ status }) {
	return /* @__PURE__ */ jsx(Tag, {
		value: STATUS_LABELS[status],
		variant: STATUS_VARIANT[status]
	});
}
//#endregion
export { ActivityEvalStatusTag };

//# sourceMappingURL=ActivityEvalStatusTag.js.map